BaseModel = require './base_model.coffee'
i18n = require '../i18n'

class global.Contact extends BaseModel
  @ATTRIBUTES = {
    id: {}
    address: {}
    business_name: {}
    base_business_name: {}
    cellphone: {}
    city: {}
    country: {}
    email: {}
    first_name: {}
    full_name: {}
    contact_group: {}
    contact_group_id: {}
    human_stage: {}
    human_previous_stage: {}
    human_recipient_status: {}
    recipient_last_flow_action_taken_state: {}
    last_name: {}
    next_valid_stages: { type: Object }
    next_valid_recipient_statuses: { type: Object }
    position: {}
    stage: {}
    previous_stage: {}
    recipient_priority: {}
    recipient_status: {}
    state: {}
    telephone: {}
    user_id: {}
    lost_reason_id: {}
    lost_reason_title: {}
    active_on_flow: {}
    stage_updated_at: {}
    updated_at: { type: Date }
    created_at: { type: Date }
    url: {}
    linkedin: {}
    interactions_with_current_flow: {}
    variable1: {}
    variable2: {}
    variable3: {}
    deleted_by_user_at: {}
    business_model_name: {}
    status_updated_at: { type: Date }
  }

  @ASSOCIATIONS = {
    business: -> Business
    user: -> User
    flow: -> Flow
    recipient: -> FlowRecipient
    tags: -> Tag
    events: -> ContactEvent
    comments: -> ContactEvent
    contact_custom_fields: -> ContactCustomField
  }

  @SERIALIZABLE_ATTRIBUTES = [
    'first_name'
    'last_name'
    'email'
    'business_name',
    'business_model_name'
    'position'
    'telephone'
    'cellphone'
    'address'
    'stage'
    'city'
    'state'
    'country'
    'contact_group_id'
    'url'
    'variable1'
    'variable2'
    'variable3'
  ]

  @SERIALIZABLE_ASSOCIATIONS = [
    'business'
    'contact_custom_fields'
  ]

  constructor: (attributes) ->
    super(attributes)

    if @business.name
      @base_business_name = @business.name
    else
      @base_business_name = ''
      @business = new Business()

  afterInitialize: ->
    @original_recipient_priority = @recipient_priority

  humanStageUpdatedAt: ->
    return '' unless @stage_updated_at
    @stage_updated_at.format('LTS')

  humalUpdatedAt: ->
    return '' unless @updated_at
    @updated_at.format('LTS')

  humalCreatedAt: ->
    return '' unless @created_at
    @created_at.format('LTS')

  stages: ->
    return [
        { value: 'smart_lead', selected: false, text: i18n.default.t('integrations.label.stages_matching.smartLead') }
        { value: 'prospect', selected: false, text: i18n.default.t('integrations.label.stages_matching.prospect') }
        { value: 'lead', selected: false, text: i18n.default.t('integrations.label.stages_matching.lead') }
        { value: 'mql', selected: false, text: i18n.default.t('integrations.label.stages_matching.mql') }
        { value: 'sql', selected: false, text: i18n.default.t('integrations.label.stages_matching.sql') }
        { value: 'opportunity', selected: false, text: i18n.default.t('integrations.label.stages_matching.opportunity') }
        { value: 'client', selected: false, text: i18n.default.t('integrations.label.stages_matching.client') }
        { value: 'lost', selected: false, text: i18n.default.t('integrations.label.stages_matching.lost') }
      ]

  hubspot_stages: ->
    return [
        { value: 'subscriber', selected: false, text: 'Subscriber' }
        { value: 'lead', selected: false, text: 'Lead' }
        { value: 'marketingqualifiedlead', selected: false, text: 'MQL' }
        { value: 'salesqualifiedlead', selected: false, text: 'SQL' }
        { value: 'opportunity', selected: false, text: 'Opportunity' }
        { value: 'customer', selected: false, text: 'Customer' }
      ]

  rd_station_stages: -> 
    return [
      { value: 'smart_lead', selected: false, text: i18n.default.t('integrations.label.stages_matching.smartLead') }
      { value: 'prospect', selected: false, text: i18n.default.t('integrations.label.stages_matching.prospect') }
      { value: 'lead', selected: false, text: i18n.default.t('integrations.label.stages_matching.lead') }
      { value: 'mql', selected: false, text: i18n.default.t('integrations.label.stages_matching.mql') }
      { value: 'sql', selected: false, text: i18n.default.t('integrations.label.stages_matching.sql') }
      { value: 'opportunity', selected: false, text: i18n.default.t('integrations.label.stages_matching.opportunity') }
    ]

  humanStatusUpdatedAt: ->
    return @recipient.humanStatusUpdatedAt() if !Array.isArray(@recipient)
    return '' unless @status_updated_at
    @status_updated_at.format('LTS')

  getNextValidStages: (hideStages = []) ->
    if hideStages.length == 0
      return @next_valid_stages
    
    stages = {}
    for key, value of @next_valid_stages
      if hideStages.includes(key)
        continue
      stages[key] = value

    return stages



// WEBPACK FOOTER //
// ./src/models/contact.coffee